<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    left2Data: {
      type: Object,
      default: () => {},
    }
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      // console.log(props)
      chart.init(props.left2Data,props.name,props.color);
      
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init() {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);


    this.state.chart.setOption({
          grid: {
            containLabel: true,
            bottom: '8%',
            top: '10%',
            left: '3%',
            right:'5%',
          },
          tooltip: {
            show:false,
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
            },
            formatter: function (value) {
              // 在标签后面添加百分号
              return value + '%';
            },
          },
          legend: {
            show:false,
            top: '8%',
            right: '10%',
            data: ['负荷情况'],
            itemWidth: 18,
            itemHeight: 18,
            itemGap: 30,
            textStyle: {
              fontSize: 18,
              color: '#C9D2FA',
              padding: [0, 0, 0, 10],
            },
          },
          xAxis: {
            // name: "班级",
            triggerEvent: true,
            data: ['灌溉用水保证率', '农业综合机械化率', '道路通达率', '农田林网覆盖率'],
            
            axisLabel: {
              interval: 0,
              show: true,
              fontSize: 16,
              color: '#C9D2FA',
              lineHeight:22,
              formatter: function (params) {
                var str = "";                 // 最终拼接成的字符串
                var paramsLen = params.length;// 获取每项文字的个数
                var len = 4;                  // 每行能显示的字的个数（根据实际情况自己设置）
                var rowNumber = Math.ceil(paramsLen / len); // 换行的话，需要显示几行，向上取整
                if (paramsLen > len) {        //大于设定的len就换行，不大于就不变化
                  for (var i = 0; i < rowNumber; i++) {
                    var temp = "";            // 表示每一次截取的字符串
                    var start = i * len;      // 开始截取的位置
                    var end = start + len;    // 结束截取的位置
                    if (i == rowNumber - 1) { // 最后一次不换行
                      temp = params.substring(start, paramsLen);
                    } else {                  // 每一次拼接字符串并换行
                      temp = params.substring(start, end) + "\n";
                    }
                    str += temp;              // 最终拼成的字符串
                  }
                } else {                      // 给新的字符串赋值
                  str = params;
                }
                return str;                   //返回字符串
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                show: false,
                color: '#F3F3F3',
                width: 2,
              },
            },

            axisTick: {
              show: false,
            },
          },
          yAxis: [
            {
              // name: '单位:万',
              // type: 'value',
              // nameTextStyle: {
              //   color: '#444444',
              // },
              splitNumber: 4,
              axisLabel: {
                show: true,
                fontSize: 18,
                color: '#C9D2FA',
                formatter: function (value) {
                  // 在标签后面添加百分号
                  return value + '%';
                },
              },
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              splitLine: {
                lineStyle: {
                  type: 'dashed',
                  color: '#3E4A82',
                },
              },
            },
          ],
          series: [
            {
              name: '达标情况',
              type: 'bar',
              silent: true,
              itemStyle: {
                color: function (params) {
                  if (params.value > 110) {
                    return '#DE4646';
                  } else if (params.value <= 110 && params.value >= 90) {
                    return '#2F8FFF';
                  } else {
                    return '#FF932F';
                  }
                },
              },
              barWidth: 30,
              data: [95, 83, 100, 95],
              label: {
                show: true, // 显示标签
                position: 'top', // 标签显示在柱状图的上方
                fontSize: 14,
                color: '#fff',
                formatter: function (params) {
                  // 在标签文本后添加百分号
                  return params.value + '%';
                },
              },
              // markLine: {
              //   symbol: 'none', // 可以设置标记点的样式，这里设置为 'none'
              //   lineStyle: {
              //     color: '#51D365', // 设置直线的颜色
              //     type: 'solid', // 设置直线的类型，可选值有：'solid', 'dashed', 'dotted' 等
              //     width: 2, // 设置直线的宽度
              //   },
              //   data: [
              //     {
              //       name: '安全线',
              //       yAxis: 100,
              //       label: {
              //         show: true,
              //         position: 'start', // 设置标签文本的位置为起始位置
              //         color: '#51D365',
              //         formatter: '安全线', // 显示标签文本为 "安全线"
              //       },
              //     },
              //   ],
              //   // label: {
              //   //   show: false,
              //   // },
              //   silent: true,
              //   // animation: true,
              // },
            },
          ],
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
